import * as Preact from "preact"

import "@frog/source/views/DevInspectorUI.less"
import Dev from "@frog/source/models/admin/Dev.js"

import App from "@frog/source/models/App.js"

import unitsprites from "@frog/source/data/unitsprites.js"
import units from "@frog/source/data/units.js"

const PROPERTY_HINTS = {
    "health": "The unit's remaining health in points.",
    "maxhealth": "The maximum number of health points for the unit",
    "key": "The unique id of the unit. It must be unique!!",
    "affiliation": "Which side the unit is on, be it good or bad or none.",
    "moverange": "How many tiles of movement the unit can take each turn.",
    "faceKey": "The face (or head) sprite, keyed from the spritesheet.",
    "bodyKey": "The body (or torso) sprite, keyed from the spritesheet.",
    "jobKey": "The job (or class) of the unit, keyed from a defined job list. Examples include sword or bow.",
    "randomJobKey": "A comma separated list of job keys to randomized between with each playthrough.",
}

const WHITELIST_FOR_NESTED_PROPERTIES = ["position"]
const PROPERTIES_LISTED_EVEN_WHEN_MISSING = ["health","maxhealth"]
const SUGGESTED_VALUES = {
    "jobKey": Object.keys(units),
    "bodyKey": Object.keys(unitsprites.bodies),
    "faceKey": Object.keys(unitsprites.faces),
    "weaponImageKey": Object.keys(unitsprites.weapons),
    "affiliation": ["good", "bad", "none", "neutral"],
}

export default class DevInpsectorUI {
    render() {
        if(App.game == undefined) return
        if(Dev.isInspectorShowing() != true) return
        const selection = App.game.chapter?.selection
        const key = selection.selectedUnitKey || selection.hoveredUnitKey
        if(key == undefined) {
            return (
                <div class="DevInspector">
                    Select a Unit
                </div>
            )
        }
        var modedInspectedUnit
        if(Dev.isEditingProto() == true) {
            modedInspectedUnit = Dev.loadedProtostage.units[key]
        } else {
            modedInspectedUnit = App.game.chapter.stage.units[key]
        }
        const isSelected = (modedInspectedUnit.key == App.game.chapter.selection.selectedUnitKey)
        // Assemble a compound stand-in unit from the multiply selected units
        if(Dev.isEditingProto() == true
        && selection.multiselectedUnitKeys.size > 1) {
            let overlappingPropertiesKeys = Object.keys(Dev.loadedProtostage.units[key])
            selection.multiselectedUnitKeys.forEach((unitKey) => {
                let overlap = overlappingPropertiesKeys.filter(
                    (propertyKey) => {
                        return Object.keys(Dev.loadedProtostage.units[unitKey]).includes(propertyKey)
                    }
                )
                overlappingPropertiesKeys = overlap
            })
            const compoundUnit = structuredClone(Dev.loadedProtostage.units[key])
            overlappingPropertiesKeys.forEach((propertyKey) => {
                selection.multiselectedUnitKeys.forEach((unitKey) => {
                    if(Dev.loadedProtostage.units[unitKey][propertyKey] != compoundUnit[propertyKey]) {
                        delete compoundUnit[propertyKey]
                    }
                })
            })
            modedInspectedUnit = new Proxy(compoundUnit, {
                set(target, propertyKey, value) {
                    selection.multiselectedUnitKeys.forEach((unitKey) => {
                        Dev.loadedProtostage.units[unitKey][propertyKey] = value
                    })
                    return true
                },
                deleteProperty(target, propertyKey) {
                    selection.multiselectedUnitKeys.forEach((unitKey) => {
                        delete Dev.loadedProtostage.units[unitKey][propertyKey]
                    })
                    return true
                }
            })
        }
        if(modedInspectedUnit == undefined) {
            return (
                <div class="DevInspector">
                    Selected unit is not defined in this mode.
                    Select anew
                </div>
            )
        }
        return (
            <div class="DevInspector" key={key} isSelected={isSelected}>
                <div class="Header">
                    <div class="Name">{modedInspectedUnit.name || "Unit"}</div>
                    <div class="Key">(#{(modedInspectedUnit.key + "").split("-")[0]})</div>
                </div>
                <form>
                    {Object.keys(modedInspectedUnit).map((key) => {
                        let propertyType = undefined
                        if(isNaN(modedInspectedUnit[key]) == false) propertyType = "number"
                        if(modedInspectedUnit[key] == null) propertyType = "text"
                        if(modedInspectedUnit[key] == "") propertyType = "text"

                        if(typeof modedInspectedUnit[key] == "string"
                        || isNaN(modedInspectedUnit[key]) == false) {
                            return (
                                <EditableProperty key={key} propertyKey={key} type={propertyType}
                                    label={key} tooltip={PROPERTY_HINTS[key]}
                                    modedUnit={modedInspectedUnit}/>
                            )
                        }
                        if(WHITELIST_FOR_NESTED_PROPERTIES.includes(key)) {
                            return (
                                <div>
                                    {
                                        Object.keys(modedInspectedUnit[key]).map((subkey) => {
                                            let propertyType = undefined
                                            if(isNaN(modedInspectedUnit[key][subkey]) == false) propertyType = "number"
                                            return (
                                                <EditableSubproperty propertyKey={key}
                                                    subpropertyKey={subkey} type={propertyType}
                                                    label={key+"."+subkey} tooltip={PROPERTY_HINTS[key]}
                                                    modedUnit={modedInspectedUnit}/>
                                            )
                                        })
                                    }
                                </div>
                            )
                        }
                    })}
                    {PROPERTIES_LISTED_EVEN_WHEN_MISSING.map((key) => {
                        if(Object.keys(modedInspectedUnit).includes(key) == false) {
                            let propertyType = undefined
                            if(isNaN(modedInspectedUnit[key]) == false) propertyType = "number"
                            return (
                                <EditableProperty propertyKey={key} type={propertyType}
                                    label={key} tooltip={PROPERTY_HINTS[key]}
                                    modedUnit={modedInspectedUnit}/>
                            )
                        }
                    })}
                    <NovelProperty
                        modedUnit={modedInspectedUnit}/>
                </form>
            </div>
        )
    }
}

class EditableProperty {
    render() {
        if(this.list != undefined) {
            return (
                <label class="EditableProperty" key={this.props.label}>
                    <datalist id={this.props.label+"SuggestedValues"}>
                        {this.list.map((suggestion, suggestionkey) =>
                            <option key={suggestionkey} value={suggestion}>
                                {suggestion}
                            </option>
                        )}
                    </datalist>
                    <div class="Label" title={this.props.tooltip}>
                        <span class="Text">{this.props.label}</span>
                    </div>
                    <input class="Value" key={this.props.label} type={this.type}
                        defaultValue={this.defaultValue} list={this.props.label+"SuggestedValues"}
                        onChange={this.onChange} onKeyDown={this.onKeyDown}/>
                </label>
            )
        }
        return (
            <label class="EditableProperty" key={this.props.label}>
                <div class="Label" title={this.props.tooltip}>
                    <span class="Text">{this.props.label}</span>
                </div>
                <input class="Value" key={this.props.label} type={this.type}
                    defaultValue={this.defaultValue} list={this.list}
                    onChange={this.onChange} onKeyDown={this.onKeyDown}/>
            </label>
        )
    }
    get list() {
        if(SUGGESTED_VALUES[this.props.propertyKey] != undefined) {
            return SUGGESTED_VALUES[this.props.propertyKey]
        }
        return undefined
    }
    get type() {
        if(this.props.type == "number") {
            return "number"
        }
        return "text"
    }
    get defaultValue() {
        return this.props.modedUnit[this.props.propertyKey]
    }
    get onKeyDown() {
        return (event) => {
            event.stopPropagation()
        }
    }
    get onChange() {
        return (event) => {
            event.preventDefault()
            let changedInput = event.target.value
            if(Dev.isEditingProto() == true) {
                Dev.saveToUndo()
            }

            if(this.props.type == "number") {
                changedInput = parseInt(changedInput || 0)
                if(isNaN(changedInput)) {
                    console.warn(event.target.value, "was expected to be a number, but is not a number.")
                }
            }

            if(changedInput == "") {
                delete this.props.modedUnit[this.props.propertyKey]
            } else {
                this.props.modedUnit[this.props.propertyKey] = changedInput
            }

            App.game.chapter.recalculateStage()
            App.game.chapter.saveStage()
            Dev.autosaveUnitsToFile()
        }
    }
}

class EditableSubproperty extends EditableProperty {
    get defaultValue() {
        return this.props.modedUnit[this.props.propertyKey][this.props.subpropertyKey]
    }
    get onChange() {
        return (event) => {
            event.preventDefault()
            let changedInput = event.target.value
            if(Dev.isEditingProto() == true) {
                Dev.saveToUndo()
            }

            if(this.props.type == "number") {
                changedInput = parseInt(changedInput || 0)
                if(isNaN(changedInput)) {
                    console.warn(event.target.value, "was expected to be a number, but is not a number.")
                }
            }

            if(this.props.modedUnit[this.props.propertyKey] != undefined) {
                if(changedInput == "") {
                    delete this.props.modedUnit[this.props.propertyKey]
                } else {
                    this.props.modedUnit[this.props.propertyKey][this.props.subpropertyKey] = changedInput
                }

                App.game.chapter.recalculateStage()
                App.game.chapter.saveStage()
                Dev.autosaveUnitsToFile()
            } else {
                console.log("Cannot write subproperty of a unit property that does not exist")
            }
        }
    }
}

class NovelProperty extends EditableProperty {
    render() {
        return (
            <label class="EditableProperty">
                <input class="Label" type="text"
                    onChange={this.onLabelChange} onKeyDown={this.onKeyDown}/>
                <input class="Value"
                    onChange={this.onChange} onKeyDown={this.onKeyDown}/>
            </label>
        )
    }
    get onChange() {
        return (event) => {
            event.preventDefault()

            this.newValue = event.target.value
        }
    }
    get onLabelChange() {
        return (event) => {
            event.preventDefault()
            let changedLabel = event.target.value

            if(changedLabel === "") return
            if(Dev.isEditingProto() == true) {
                Dev.saveToUndo()
            }

            this.props.modedUnit[changedLabel] = this.newValue || null

            App.game.chapter.recalculateStage()
            App.game.chapter.saveStage()
            Dev.autosaveUnitsToFile()
        }
    }
}
